import { createAction, props } from '@ngrx/store';
import { Geovisitas } from '../metricas.model';


export const cargaGeo= createAction(
  '[GEOvisitas] Carga',
  props<{ geovisitas: Geovisitas[] }>()
  );
export const limpiaGeo = createAction('[GEOvisitas] Remueve');
